import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'
import ImageBlockPrototype from '/react4xp/components/prototype/ImageBlock'
import type { ImageBlockImage } from '/react4xp/components/prototype/ImageBlock/types'

type ImageBlockMacroImage = {
	src: string
	alt?: string
	caption?: string
}

type ImageBlockMacroData = {
	images?: ImageBlockMacroImage[]
}

export const ImageBlockMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	const { images = [] } = (data || {}) as ImageBlockMacroData

	// No `container` here, unlike the Part: the macro is embedded in a rich text
	// field that is already inside its parent component's container.
	return (
		<ImageBlockPrototype
			images={images.map<ImageBlockImage>((image) => ({
				src: image.src,
				alt: image.alt || '',
				caption: image.caption,
			}))}
		/>
	)
}
